module.exports = __webpack_public_path__ + "img/category_23.9b635d19.png";